// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tsareena: PokeData = {
  "id": 763,
  "name": "tsareena",
  "height": 12,
  "weight": 214,
  "base_experience": 230,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "double-slap",
    "stomp",
    "razor-leaf",
    "high-jump-kick",
    "splash",
    "flail",
    "swagger",
    "rapid-spin",
    "sweet-scent",
    "teeter-dance",
    "aromatherapy",
    "magical-leaf",
    "punishment",
    "leaf-storm",
    "power-whip",
    "captivate",
    "play-nice",
    "aromatic-mist",
    "trop-kick"
  ],
  "moves": [
    "razor-leaf",
    "splash",
    "aromatherapy",
    "power-whip",
    "bullet-seed",
    "frenzy-plant",
    "wood-hammer",
    "synthesis",
    "leaf-tornado",
    "solar-beam",
    "energy-ball",
    "vine-whip",
    "grassy-terrain"
  ],
  "evolution_chain": {
    "id": 392,
    "item": null,
    "species": [
      {
        "name": "bounsweet",
        "order": 761,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "steenee",
        "order": 762,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 761,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "tsareena",
        "order": 763,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 762,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "stomp"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 123,
    "speed": 104,
    "ability_power": 173
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
